import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dffb0dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-reply me-2" }, null, -1))
const _hoisted_2 = { class: "card bg-light my-3" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-file-alt mt-1 me-2" }, null, -1))
const _hoisted_5 = { class: "card-actions float-end" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-edit me-1" }, null, -1))
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "table table-borderless table-sm mb-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"200px"} }, "ประกาศใช้เมื่อ:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"200px"} }, "จำนวนเขตตรวจราชการ:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"200px"} }, "สถานะ:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_AppointmentRegionListComponent = _resolveComponent("AppointmentRegionListComponent")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "btn btn-secondary",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backClick && _ctx.backClick(...args)))
    }, [
      _hoisted_1,
      _createTextVNode("ถอยกลับ ")
    ]),
    _createElementVNode("div", null, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(_toDisplayString(_ctx.appointment?.name) + " ", 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editClick && _ctx.editClick(...args))),
                    disabled: _ctx.appointment?.status !== 0
                  }, [
                    _hoisted_7,
                    _createTextVNode("แก้ไข ")
                  ], 8, _hoisted_6)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("table", _hoisted_9, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_10,
                      _createElementVNode("td", null, _toDisplayString(_ctx.appointment ? _ctx.thaiDate(_ctx.appointment.startDate) : ''), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_11,
                      _createElementVNode("td", null, _toDisplayString(_ctx.appointmentRegions ? _ctx.appointmentRegions.length : 0), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_12,
                      _withDirectives(_createElementVNode("td", null, null, 512), [
                        [_directive_dompurify_html, _ctx.appointment ? _ctx.statusHtml(_ctx.appointment.status) : '']
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode(_component_AppointmentRegionListComponent, {
              "appointment-id": _ctx.appointment?.id,
              "appointment-status": _ctx.appointment?.status
            }, null, 8, ["appointment-id", "appointment-status"])
          ], 64))
    ])
  ], 64))
}